import * as React from "react";

const NotificationIcon = (props) => {
  return (
    <>
      
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={28}
          fill="none"
          {...props}
        >
          <path
            fill="#64748B"
            d="M22.379 19.42a7.419 7.419 0 0 1-2.636-5.676v-3.088c0-3.898-2.895-7.124-6.645-7.665V1.795a1.107 1.107 0 1 0-2.215 0v1.196c-3.752.541-6.646 3.767-6.646 7.665v3.088c0 2.192-.96 4.261-2.645 5.686-.43.368-.678.904-.678 1.472a1.94 1.94 0 0 0 1.938 1.938h18.276a1.94 1.94 0 0 0 1.938-1.938c0-.568-.247-1.104-.687-1.481ZM11.991 27.27a4.16 4.16 0 0 0 4.07-3.322H7.92a4.16 4.16 0 0 0 4.07 3.322Z"
            style={{
              fill: "#64748B",
              fillOpacity: 1,
            }}
          />
        </svg>
    
    </>
  );
};
export default NotificationIcon;
